import {
    GET_B2B_USERS_REPORT,
    SELECT_B2B_USER,
    ADD_TRANSFER,
    GET_B2B_USERS_TOTAL_DEBT
} from './b2bUsersReport.actionsTypes';

export default function b2bUsersReport(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_B2B_USERS_REPORT:
            return {
                ...newState,
                list: action.payload
                    ? action.payload.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    : []
            };
        case SELECT_B2B_USER:
            return {
                ...newState,
                activeB2bUser: action.activeB2bUser
            };
        case ADD_TRANSFER:
            return {
                ...newState,
            };
        case GET_B2B_USERS_TOTAL_DEBT:
            return {
                ...newState,
                b2bUsersTotalDebt: action.b2bUsersTotalDebt
            };
        default:
            return newState;
        }
}